import { createScopedReducer } from '@mews/framework';

import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { REBATE_FORM_INIT_FAILED, REBATE_FORM_INIT_STARTED, REBATE_FORM_INIT_SUCCEEDED } from './actions/actionTypes';

export default createScopedReducer(META_STATE_SUCCEEDED.meta, {
    ...createEntityAsyncMetaHandlers({
        STARTED: REBATE_FORM_INIT_STARTED,
        SUCCEEDED: REBATE_FORM_INIT_SUCCEEDED,
        FAILED: REBATE_FORM_INIT_FAILED,
    }),
});
